<template>
  <el-dialog
    v-loading="loading"
    class="reservedPinDialog"
    :visible.sync="visible"
    :before-close="handleClose"
    append-to-body
    :width="width"
  >
    <template v-if="!loading">
      <img
        slot="title"
        src="@/assets/images/logo.png"
      />
      <div class="reservedPinDialog__content">
        <p>
          {{ $t('reserved.pin.dialog.text')}}
        </p>

        <el-form @submit.native.prevent="handleVerification">

          <CodeInput @onchange="setCode" />

          <el-button
            type="primary"
            native-type="submit"
            class="reservedPinDialog__button"
            :loading="loading"
            @click="handleVerification"
          >{{ $t('reserved.pin.dialog.button')}}</el-button>
        </el-form>

        <p
          v-if="invalid"
          class="reservedPinDialog__invalid"
        >
          {{ $t('reserved.pin.dialog.invalidCode')}}
        </p>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import CodeInput from '@/components/ui/CodeInput'
export default {
  name: 'RecordPinDialog',
  components: {
    CodeInput
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    invalid: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    width: '400px',
    windowWidth: 0,
    loading: false,
    code: null
  }),
  watch: {
    windowWidth(newWidth, oldWidth) {
      this.width = newWidth < 400 ? '100%' : '400px'
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
    // init
    this.windowWidth = window.innerWidth
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    setCode(code) {
      this.code = code
    },
    handleVerification() {
      if (this.code) {
        this.$emit('verification', this.code.toUpperCase())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.reservedPinDialog';

#{$c} {
  text-align: center;

  p {
    word-break: normal;
  }

  img {
    height: 60px;
    width: auto;
    text-align: left;
  }

  &__content {
    img {
      z-index: 2;
      position: absolute;
      bottom: 0;
      right: 0;
      height: 80%;
      width: auto;
    }
    p {
      padding: 20px;
      font-weight: 700;
    }
  }

  &__radio {
    background-color: #dddddd;
    width: 100%;
    z-index: 1;
  }
  &__radio ul {
    position: relative;
    list-style: none;
    padding: 20px;
    max-width: 70%;
  }
  &__radio li:before {
    content: '\2022';
    color: red;
    font-size: 24px;
    padding: 5px;
  }

  &__button {
    margin: 15px auto;
    text-transform: uppercase;
  }

  &__invalid {
    color: red;
  }
}
</style>